import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { TextInputComponent } from '../../../shared/components/text-input/text-input.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NotificationService } from '../../service/notification.service';
import { AuthService } from '../../service/auth-service';
import { MatDialog } from '@angular/material/dialog';
import {
  emailValidator,
 passwordValidator,
  checkPasswordMismatch
} from '../../../shared/validators/common.validators';
import { phoneValidator } from '../../../shared/validators/phone-validator';

@Component({
  selector: 'app-nri-signup',
  imports: [
    TextInputComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  templateUrl: './nri-signup.component.html',
  styleUrl: './nri-signup.component.css',
})
export class NriSignupComponent {
  signUpForm!: FormGroup;
  isPasswordVisible = false;
  isConfirmPasswordVisible = false;
  loading: boolean = false;
  passwordMismatch: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private toastr: NotificationService,
    private dialog: MatDialog,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.signUpForm = this.formBuilder.group({
      firstName: new FormControl('', [
        Validators.required,
        Validators.maxLength(50),
      ]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.maxLength(50),
      ]),
      mobileNumber: new FormControl('', [
        Validators.required,
        Validators.minLength(7),
        Validators.maxLength(15),
        phoneValidator(),
      ]),
      email: new FormControl('', emailValidator),
      password: new FormControl('',  [Validators.required,passwordValidator]),
      confirmPassword: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.addClass(document.body, 'nri-signup-body');
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.removeClass(document.body, 'nri-signup-body');
    }
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  toggleConfirmPasswordVisibility() {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  }

  getControl(fieldName: string): FormControl {
    return (this.signUpForm.get(fieldName) as FormControl) || new FormControl();
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormControl) {
        control.markAsTouched();
        control.markAsDirty();
      }
    });
  }

  signUp() {
  this.markFormGroupTouched(this.signUpForm);
  this.passwordMismatch = false;

  if (this.signUpForm.valid) {
    if (
      this.signUpForm.value.password !== this.signUpForm.value.confirmPassword
    ) {
      this.passwordMismatch = true;
      return;
    }

    this.loading = true;

    const payload = {
        firstName: this.signUpForm.value.firstName,
        lastName: this.signUpForm.value.lastName,
        mobileNumber: this.signUpForm.value.mobileNumber,
        email: this.signUpForm.value.email,
        password: this.signUpForm.value.password,
        userType: 'NRI',
        username: this.signUpForm.value.email,
        providerId: null
    };

    this.authService.nriSignUp(payload).subscribe({
      next: (res) => {
        if (res) {
          this.toastr.success({
            message: 'Registration successful',
          });
          this.router.navigate(['login']);
          this.loading = false;
        }
      },
      error: (err) => {
        this.loading = false;

        const errorMessage =
          err?.error?.error?.message ||
          err?.error?.message ||
          err?.message ||
          'Registration failed. Please try again.';

        this.toastr.error({ title: 'Error', message: errorMessage });
      },
      complete: () => {},
    });
  }
}

get passwordErrors() {
    return this.signUpForm.get('password')?.errors || {};
  }

get passwordsMismatch() {
    return checkPasswordMismatch(this.signUpForm);
  }

}
